import { A } from '@adornis/base/env-info.js';
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import type { NonOptionalOptions } from '@adornis/validation/functions/nonOptional.js';
import type { ValidationFunction } from '@adornis/validation/validator.js';

/**
 * literally the same a the function in engine. But it is translated to german and uses the client translator to translate the fields
 */
export const sgNonOptional =
  ({ translationKey = 'validation_non_optional', allowFalsy }: NonOptionalOptions = {}): ValidationFunction<any, any> =>
  options => {
    if (options.value === undefined || options.value === null || (!allowFalsy && !options.value)) {
      if (!A.isServer)
        throw new ValidationError(
          `Feld "${clientTranslator.translate('field', options.key) as string}" muss ausgefüllt werden!`,
          { key: options.key, translationKey, path: options.path },
        );
      else
        throw new ValidationError(`Feld "field.${options.key}" muss ausgefüllt werden!`, {
          key: options.key,
          path: options.path,
          translationKey,
        });
    }
  };
